import beApiClient from "@/src/be-api-client";

// filter delay method, defaults to 500ms
export function createDebounce() {
  let timeout = null;
  return function (fnc, delayMs) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fnc();
    }, delayMs || 500);
  };
};

function parseErrorResponse(errorResponse) {
  if(errorResponse.data.errors) {
    return errorResponse.data.errors;
  }

  if(errorResponse.status === 404) {
    return 'Entity Not Found';
  }

  return errorResponse;
}

export function handleErrors(response) {
  if (response.message) {
    const errors = parseErrorResponse(response.response);
    let errorStrings;
    if(errors && typeof errors === 'object') {
      const errorValues = Object.values(errors);
      errorStrings = Array.isArray(errorValues) ? errorValues.join(', ') : errorValues;
    } else {
      errorStrings = errors;
    }
    const message = (`${errorStrings}`);
    return message;
  } else {
    return response;
  }
};

export function makeRequest(method, url, payload = null) {
  return new Promise((resolve, reject) => {
    method(url, payload).then(response => {
      resolve(response.data);
    }).catch(error => {
      const message = handleErrors(error);
      reject(message);
    })
  })
};

// Generic load data method
/**
 * Helper method to get data from a URL and add to an object
 * @param {Object} entity: The object to load the data into
 * @param {String} url: String
 * @param {String} key: 
 * @param {Object} params 
 * @returns 
 */
export function getDataForEntity(entity, key, url, params = {}) {
  return new Promise((resolve, reject) => {
    beApiClient.get(url, params).then(response => {
      entity[key] = response.data;
      resolve();
    }).catch(error => {
      const message = handleErrors(error);
      reject(message);
    });
  });
};

/**
 * Fetches a resource from the API and assigns the response data to `this[key]`.
 *
 * @param {string} url - The API endpoint path.
 * @param {string} key - The property name on `this` to assign the response data to.
 * @param {object} [params={}] - Optional query parameters to include in the request.
 * @returns {Promise<void>} Resolves on success; rejects with an error message string on failure.
 */
export function loadEntity(entity, url, key, params = {}) {
  return new Promise((resolve, reject) => {
    beApiClient.get(url, params).then(response => {
      entity[key] = response.data;
      resolve();
    }).catch(error => {
      const message = handleErrors(error);
      reject(message);
    });
  });
};

/**
 * Fetches a paginated resource from the API and assigns the response data to `entity[key]`.
 *
 * @param {object} entity - The object to assign the response data to (e.g. `this` in a store action).
 * @param {string} url - The API endpoint path.
 * @param {string} key - The property name on `entity` to assign the response data to.
 * @param {object} [params={}] - Optional query parameters to include in the request.
 * @returns {Promise<any>} Resolves with the response data on success; rejects with an error message string on failure.
 */
export function loadPaginatedEntity(entity, url, key, params = {}) {
  return new Promise((resolve, reject) => {
    beApiClient.get(url, {
      headers: { 'Accept': 'application/json' },
      params: params
    }).then(response => {
      entity[key] = response.data;
      resolve(response.data);
    }).catch(error => {
      const message = handleErrors(error);
      reject(message);
    });
  });
}
